// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"69b9df4b","393":"69b9df4b","742":"69b9df4b","973":"24263fa7"}[chunkId] + ".chunk.css";
};